var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FieldLabel, FieldWrapper, FlexBox, Icon, InputText, Tooltip, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import * as React from 'react';
import { durationConverter } from 'utils/duration';
function convertValueToNumber(value) {
    let numberValue = value;
    if (typeof numberValue === 'string') {
        numberValue = parseInt(numberValue, 10) || 0;
    }
    if (numberValue === null) {
        return 0;
    }
    return numberValue;
}
function getSplitTimeUnits(value, includeDays) {
    return durationConverter.splitTimeUnits(convertValueToNumber(value), includeDays);
}
function getInternalValue(seconds, includeDays) {
    const timeValues = getSplitTimeUnits(seconds, includeDays);
    const timeValuesKeys = Object.keys(timeValues);
    return timeValuesKeys.reduce((acc, key) => {
        return Object.assign(Object.assign({}, acc), { [key]: timeValues[key].toString() });
    }, {});
}
export class FieldDuration extends React.PureComponent {
    static getDerivedStateFromProps(props, state) {
        if (props.input.value !== state.value) {
            return {
                value: props.input.value,
                internalValues: getInternalValue(props.input.value, props.includeDays),
            };
        }
        return null;
    }
    constructor(props) {
        super(props);
        this.getSecondsInput = this.createInputGetter('seconds');
        this.getMinutesInput = this.createInputGetter('minutes');
        this.getHoursInput = this.createInputGetter('hours');
        this.getDaysInput = this.createInputGetter('days');
        this.state = {
            value: props.input.value,
            internalValues: getInternalValue(props.input.value, props.includeDays),
        };
    }
    internalValueFormatter(value) {
        const valueNumber = parseInt(value, 10) || 0;
        if (Number.isNaN(valueNumber) || valueNumber < 0) {
            return '0';
        }
        return value;
    }
    createInputGetter(timeKey) {
        return () => {
            const { internalValues } = this.state;
            // const value = this.getTimeValues()[timeKey];
            const internalValue = internalValues[timeKey];
            return {
                name: `${this.props.input.name || 'duration'}-${timeKey}`,
                value: internalValue !== null && internalValue !== void 0 ? internalValue : '',
                onBlur: this.handleChange,
                onChange: (e) => {
                    this.setState({
                        internalValues: Object.assign(Object.assign({}, internalValues), { [timeKey]: this.internalValueFormatter(e.target.value) }),
                    });
                },
            };
        };
    }
    combineInternalToValue() {
        const { internalValues } = this.state;
        return durationConverter.combineTimeUnits(convertValueToNumber((internalValues === null || internalValues === void 0 ? void 0 : internalValues.days) || 0), convertValueToNumber(internalValues.hours || 0), convertValueToNumber(internalValues.minutes || 0), convertValueToNumber(internalValues.seconds || 0));
    }
    setInternalValue(seconds, includeDays) {
        this.setState({
            internalValues: getInternalValue(seconds, includeDays),
        });
    }
    handleChange() {
        const timeValues = getSplitTimeUnits(this.combineInternalToValue(), this.props.includeDays);
        const seconds = durationConverter.combineTimeUnits(timeValues.days || 0, timeValues.hours, timeValues.minutes, timeValues.seconds);
        this.setInternalValue(seconds, this.props.includeDays);
        this.triggerChange(Math.max(0, seconds));
    }
    triggerChange(value) {
        const { input } = this.props;
        const { onChange } = input;
        onChange(value);
    }
    render() {
        const { icon, tooltip, includeDays, label, meta, noAlert, className, required, } = this.props;
        const boxMargin = {
            flex: '1',
            margin: '0 0 0 200',
        };
        const daysInput = this.getDaysInput();
        const hoursInput = this.getHoursInput();
        const minutesInput = this.getMinutesInput();
        const secondsInput = this.getSecondsInput();
        return (_jsx(FieldWrapper, Object.assign({ meta: meta, required: required, label: label, noLabel: !label, noAlert: noAlert }, { children: _jsxs(FlexBox, Object.assign({ alignItems: "center", justifyContent: "space-between", width: "100%", className: className }, { children: [icon && (_jsx(Tooltip, Object.assign({ content: tooltip, dark: true }, { children: _jsx(Box, Object.assign({ padding: "500 300 100 0" }, { children: _jsx(Icon, { name: icon, size: 16 }) })) }))), includeDays && (_jsxs(Box, Object.assign({ flex: "1" }, { children: [_jsx(Box, Object.assign({ margin: "0 0 100" }, { children: _jsx(FieldLabel, Object.assign({ required: !label && required, htmlFor: daysInput.name }, { children: "Days(s)" })) })), _jsx(InputText, Object.assign({ type: "number", min: 0, step: 1 }, daysInput))] }))), _jsxs(Box, Object.assign({}, (includeDays ? boxMargin : {}), { children: [_jsx(Box, Object.assign({ margin: "0 0 100" }, { children: _jsx(FieldLabel, Object.assign({ required: !label && required, htmlFor: hoursInput.name }, { children: "Hour(s)" })) })), _jsx(InputText, Object.assign({ type: "number", min: 0, step: 1 }, hoursInput))] })), _jsxs(Box, Object.assign({}, boxMargin, { children: [_jsx(Box, Object.assign({ margin: "0 0 100" }, { children: _jsx(FieldLabel, Object.assign({ required: !label && required, htmlFor: minutesInput.name }, { children: "Minute(s)" })) })), _jsx(InputText, Object.assign({ type: "number", min: 0, max: 60, step: 1 }, minutesInput))] })), !includeDays && (_jsxs(Box, Object.assign({}, boxMargin, { children: [_jsx(Box, Object.assign({ margin: "0 0 100" }, { children: _jsx(FieldLabel, Object.assign({ required: !label && required, htmlFor: secondsInput.name }, { children: "Second(s)" })) })), _jsx(InputText, Object.assign({ type: "number", min: 0, step: 1 }, secondsInput))] })))] })) })));
    }
}
FieldDuration.defaultProps = {
    meta: {},
};
__decorate([
    boundMethod
], FieldDuration.prototype, "handleChange", null);
